import Authorizations from '../index.authorizations';

export const findAuthorization = (authorizationKey: string) => {
    const authorization = Authorizations.find(auth => auth.keys.indexOf(authorizationKey) !== -1);

    return authorization || false;
};
